import {MapPage} from "../MapPage";

export const AddPage=()=>{  
  return( 
    <>      
      <MapPage/>
    </>      
  )   
}